<div class="container-fluid">
  <div class="row justify-content-start">
    <div class="col-12">
      <!-- Title -->
      <h1 class="fw-semibold fs-3 fs-lg-1 lh-sm ls-1 text-dark mb-4">
        {{ 'translate_return_policy' | translate }}
      </h1>

      <!-- Introduction Title -->
      <h2 class="fw-semibold fs-5 fs-lg-5 lh-sm ls-1 text-dark mb-3 d-flex align-items-start">
        {{ 'returns_and_exchanges' | translate }}
      </h2>
      
      <!-- Introduction Content -->
      <p class="fw-normal fs-5 fs-lg-5 lh-sm ls-1 text-secondary mb-5">
        {{ 'translate_return_policy_intro' | translate }}
      </p>
      
      <!-- Section 1: Return Eligibility -->
      <div class="mb-5">
        <h2 class="fw-semibold fs-5 fs-lg-5 lh-sm ls-1 text-dark mb-3 d-flex align-items-start">
          {{ 'translate_return_policy_section_1_title' | translate }}
        </h2>
        <ul class="list-unstyled ps-0 m-0 mx-4">
          <li class="fw-normal fs-5 fs-lg-5 lh-sm ls-1 text-secondary mb-3 ps-4 position-relative">
            <span class="position-absolute start-0 w-1 h-1 bg-dark rounded-circle" style="top: 8px;"></span>
            @if (this.translateService.currentLang == 'ar') {
              <span>
                تواصل مع فريق خدمة العملاء على
                <a href="mailto:support@Glamera.com" style="color: #0B81F6; text-decoration: none;">support&#64;Glamera.com</a> 
                لطلب رقم تفويض الإرجاع.
              </span>
            } @else {
              <span>
                Contact our customer service team at 
                <a href="mailto:support@Glamera.com" style="color: #0B81F6; text-decoration: none;">support&#64;Glamera.com</a> 
                to request a Return Authorization Number.
              </span>
            }
          </li>
          <li class="fw-normal fs-5 fs-lg-5 lh-sm ls-1 text-secondary mb-3 ps-4 position-relative">
            <span class="position-absolute start-0 w-1 h-1 bg-dark rounded-circle" style="top: 8px;"></span>
            {{ 'translate_return_policy_section_1_item_2' | translate }}
          </li>
        </ul>
      </div>
      
      <!-- Section 2: Return Process -->
      <div class="mb-5">
        <h2 class="fw-semibold fs-5 fs-lg-5 lh-sm ls-1 text-dark mb-3 d-flex align-items-start">
          {{ 'translate_return_policy_section_2_title' | translate }}
        </h2>
        <ul class="list-unstyled ps-0 m-0 mx-4">
          <li class="fw-normal fs-5 fs-lg-5 lh-sm ls-1 text-secondary mb-3 ps-4 position-relative">
            <span class="position-absolute start-0 w-1 h-1 bg-dark rounded-circle" style="top: 8px;"></span>
            {{ 'translate_return_policy_section_2_item_1' | translate }}
          </li>
          <li class="fw-normal fs-5 fs-lg-5 lh-sm ls-1 text-secondary mb-3 ps-4 position-relative">
            <span class="position-absolute start-0 w-1 h-1 bg-dark rounded-circle" style="top: 8px;"></span>
            {{ 'translate_return_policy_section_2_item_2' | translate }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>